document.addEventListener('DOMContentLoaded', function() {

  // Details Modal Script *************************************************

// Handler global para todos os botões .close-button (funciona mesmo após trocar HTML)
document.addEventListener('click', function (e) {
const btn = e.target.closest('.close-button');
if (!btn) return;

const parts = btn.id.split('-'); // ex: "close-123"
const modalId = parts[1];

// Tenta fechar ambos os tipos de modal, se existirem
const detailsModal = document.getElementById('ModalDetails-' + modalId);
const infoModal    = document.getElementById('ModalProductInfo-' + modalId);

if (detailsModal) detailsModal.removeAttribute('open');
if (infoModal)    infoModal.removeAttribute('open');
});


  function detailsModal() {
    // Select all elements where the ID starts with 'details-'
    const detailButtons = document.querySelectorAll('[id^="details-"]');
    
    // Loop through each detail button
    detailButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
  
        console.log("DetailButtons has been clicked");
  
        // Extract the variant ID from the button's ID
        const variantId = this.id.split('-')[1]; // Extracts the part after 'details-'
  
        // Get the corresponding modal (assuming the modal ID is 'ModalDetails-variantId')
        const modal = document.getElementById('ModalDetails-' + variantId);
  
        if (modal) {
          modal.show(this); // Open the modal
        } else {
          console.error('Modal not found for variant ID:', variantId);
        }
      });
    });
    
  }




// Saber Mais Modal Script **********************************************


  function productInfoModal() {
    // Select all elements where the ID starts with 'details-'
    const productInfoButtons = document.querySelectorAll('[id^="productInfo-"]');
    
    // Loop through each detail button
    productInfoButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
  
        console.log("productInfoButtons has been clicked");
  
        // Extract the variant ID from the button's ID
        const variantId = this.id.split('-')[1]; // Extracts the part after 'details-'
  
        // Get the corresponding modal (assuming the modal ID is 'ModalDetails-variantId')
        const modal = document.getElementById('ModalProductInfo-' + variantId);
  
        if (modal) {
          modal.show(this); // Open the modal
        } else {
          console.error('Modal not found for variant ID:', variantId);
        }
      });
    });
    
  }


  if (window.Shopify && Shopify.routes && window.location.pathname.startsWith(`${Shopify.routes.root}products/`)) {

  detailsModal();

    // Call the function when DOM is fully loaded
    document.addEventListener('DOMContentLoaded', function() {
        detailsModal();
    });
  }
  //***********************************************************************************
  
 if (window.Shopify && Shopify.routes && window.location.pathname.startsWith(`${Shopify.routes.root}collections/`)) {
    const stickyTotalItems = document.getElementById('total-items');
    const stickyTotalPrice = document.getElementById('total-price');
    const stickyAddToCartButton = document.getElementById('add-to-cart-sticky');
    const stickyBar = document.getElementById('sticky-bar');
    const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    const currentURL = window.location.pathname.replace(ROOT, ''); // remove /pt-pt/
    const parts = currentURL.split('/').filter(Boolean);
    const categoryFromURL = parts[parts.length - 1];
    const subscriptionRadio = document.getElementById("sub-p");
    const oneTimeRadio = document.getElementById("one-time-p");



    // Function to set the active class based on the URL
    function setActiveCategory() {
        const categoryButtons = document.querySelectorAll('.category-btn');

        // Loop through buttons and match data-category with the URL category
        categoryButtons.forEach(button => {
            const category = button.getAttribute('data-category');
            
            if (category === categoryFromURL) {
                // Remove 'active' from any previously active button
                categoryButtons.forEach(btn => btn.classList.remove('active'));

                // Add 'active' class to the matched button
                button.classList.add('active');

                // Optionally, trigger the category switch (similar to what happens on click)
                fetchCategoryProducts(category);
            }
        });
    }

    // Function to fetch and replace products when switching categories
    function fetchCategoryProducts(category) {
        const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        fetch(`${ROOT}collections/${category}`)
            .then(response => response.text())
            .then(data => {
                // Replace the current products with the new ones
                document.querySelector('.bundle-products').innerHTML = new DOMParser()
                    .parseFromString(data, 'text/html')
                    .querySelector('.bundle-products').innerHTML;

                // Reattach event listeners for new content
                attachQuantityButtons();
                detailsModal();
                productInfoModal();
                loadSelections(); // Load previous selections and reflect in sticky bar
                console.log(`Category loaded: ${category}`);
            })
            .catch(error => console.error('Error fetching category products:', error));
    }

    // Call the function on page load
    setActiveCategory();

    // Wait until Swiper is fully loaded
    function initSwiper() {
      if (typeof Swiper !== 'undefined') {
        var swiper = new Swiper('.swiper', {
          direction: 'horizontal',
          slidesPerView: 'auto', // Display 4 buttons at once
          spaceBetween: 0, // Add space between buttons
          grabCursor: true, // Makes the slider draggable
          loop: false, // Disable looping
          autoplay: false, // Disable autoplay
          watchOverflow: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: false, // No pagination
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true, // Enable dragging of the scrollbar
          },
        });
      } else {
        setTimeout(initSwiper, 50); // Retry if Swiper is not yet loaded
      }
    }

    initSwiper();


    // Function to throttle events
    function throttle(func, limit) {
        let lastFunc;
        let lastRan;
        return function() {
            const context = this;
            const args = arguments;
            if (!lastRan) {
                func.apply(context, args);
                lastRan = Date.now();
            } else {
                clearTimeout(lastFunc);
                lastFunc = setTimeout(function() {
                    if (Date.now() - lastRan >= limit) {
                        func.apply(context, args);
                        lastRan = Date.now();
                    }
                }, limit - (Date.now() - lastRan));
            }
        };
    }

  
    function attachQuantityButtons() {
    document.querySelectorAll('quantity-input.quantity').forEach((qtyEl) => {
        const input = qtyEl.querySelector('input.quantity-input');
        const minusBtn = qtyEl.querySelector('.minus-btn');
        const plusBtn  = qtyEl.querySelector('.plus-btn');

        if (!input || !minusBtn || !plusBtn) return;

        const variantId =
        minusBtn.dataset.variantId ||
        input.dataset.quantityVariantId || // from your HTML
        null;

        const setMinusState = () => {
        const q = parseInt(input.value, 10) || 0;
        minusBtn.disabled = q <= 0;
        minusBtn.style.opacity = q <= 0 ? '0.4' : '1';
        };

        // initial state
        setMinusState();

        // + button
        plusBtn.addEventListener('click', () => {
            input.value = (parseInt(input.value, 10) || 0);
            setMinusState();

            // example: read price within the same row to avoid cross-matching
            const row = qtyEl.closest('.variant-row');
            const priceEl = row?.querySelector('.variant-info .variant-price');
            const pricePerUnit = priceEl ? priceEl.innerText.replace('€','').trim().replace(',', '.') : '0';

            const selling_plan = document.getElementById(`selling-plan-${variantId}`)?.value || null;
            const variantImage = document.getElementById(`image-${variantId}`)?.src || null;
            const variantName  = document.getElementById(`name-${variantId}`)?.textContent || null;

            console.log("Input Value is", parseInt(input.value, 10) || 0);

            saveSelection(variantId, parseInt(input.value, 10) || 0, pricePerUnit, selling_plan, variantImage, variantName);
        updateStickyBar();
        });

        // – button
        minusBtn.addEventListener('click', () => {
            const q = Math.max((parseInt(input.value, 10) || 0), 0);
            input.value = q;
            setMinusState();

            const row = qtyEl.closest('.variant-row');
            const priceEl = row?.querySelector('.variant-info .variant-price');
            const pricePerUnit = priceEl ? priceEl.innerText.replace('€','').trim().replace(',', '.') : '0';

            const selling_plan = document.getElementById(`selling-plan-${variantId}`)?.value || null;
            const variantImage = document.getElementById(`image-${variantId}`)?.src || null;
            const variantName  = document.getElementById(`name-${variantId}`)?.textContent || null;

            saveSelection(variantId, q, pricePerUnit, selling_plan, variantImage, variantName);
            updateStickyBar();
        });
    });
    }

    // Call the function when DOM is fully loaded
    document.addEventListener('DOMContentLoaded', function() {
        attachQuantityButtons();
        detailsModal();
        productInfoModal();
    });



    // Free shipping threshold
    const freeShippingThreshold = 40;
    
    // Function to update the sticky bar with total items and price from localStorage (all categories)
    function updateStickyBar() {
        let totalPrice = 0;
        let totalItems = 0;
    
        const storedSelections = JSON.parse(localStorage.getItem('selectedItems')) || [];
    
        // Aggregate total items and price from all categories
        storedSelections.forEach(item => {
            totalItems += item.quantity;
            totalPrice += parseFloat(item.price) * item.quantity;
        });
    
        // Update sticky bar with total items and price
        stickyTotalItems.innerText = `${totalItems}`;
        stickyTotalPrice.innerText = `${totalPrice.toFixed(2).replace('.', ',')} €`;
    
        // Calculate progress towards free shipping
        const percentageProgress = Math.min((totalPrice / freeShippingThreshold) * 100, 100); // Max at 100%
        const remainingAmount = Math.max(freeShippingThreshold - totalPrice, 0).toFixed(2);
    
        // Update progress bar width
        const progressBar = document.querySelector('.progress');
        progressBar.style.width = `${percentageProgress}%`;
    
        // Update progress text (e.g., amount left for free shipping)
        const progressText = document.querySelector('.progress-bar-text');
        const progressTextUnl = document.querySelector('.progress-bar-text-unl');
        const dynamicAmount = document.getElementById('dynamicAmount');
    
        dynamicAmount.innerText = `${remainingAmount}`;
    
        if (totalPrice >= freeShippingThreshold) {
            progressText.style.display = 'none';
            progressTextUnl.style.display = 'block';
        } else {
            progressText.style.display = 'block';
            progressTextUnl.style.display = 'none';
        }
    
        // Add or remove disabled class based on the total price
        if (totalPrice === 0) {
            stickyAddToCartButton.classList.add('disabled');
            stickyAddToCartButton.disabled = true;
        } else {
            stickyAddToCartButton.classList.remove('disabled');
            stickyAddToCartButton.disabled = false;
        }
    
        // Log for debugging
        console.log('Sticky bar updated:', { totalItems, totalPrice, percentageProgress, remainingAmount });
    }


    // Function to reset selections after adding to cart
    function resetSelections() {
        // Clear localStorage
        localStorage.removeItem('selectedItems');

        // Reset the sticky bar totals
        stickyTotalItems.innerText = '0';
        stickyTotalPrice.innerText = '0,00 €';

        // Reset all quantity inputs to zero
        document.querySelectorAll('input[type="number"]').forEach(input => {
            input.value = 0;
            console.log("Reset completed", input.value);
        });

        console.log('Selections and sticky bar reset after add to cart');
    }
  
    // Function to save selections in localStorage (persists across categories)
    function saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName) {
        let storedSelections = JSON.parse(localStorage.getItem('selectedItems')) || [];
        const existingItemIndex = storedSelections.findIndex(item => item.id === variantId);
    
        if (existingItemIndex !== -1) {
    
            const selectedItem = storedSelections[existingItemIndex];
    
            // Check if originalPrice is undefined or not a valid number
            if (typeof selectedItem.originalPrice === 'undefined' || isNaN(selectedItem.originalPrice)) {
                selectedItem.originalPrice = price; // Store the original price
                console.log("Original price stored for the first time:", selectedItem.originalPrice);
            }
    
            if (subscriptionRadio.checked && selling_plan !== null && !selectedItem.discountApplied) {
                price = price * 0.85; // Apply 15% discount
                storedSelections[existingItemIndex].price = price;
                selectedItem.discountApplied = true; // Mark that discount has been applied
                console.log("Discount applied. New price:", price);
            } else if (oneTimeRadio.checked && selling_plan !== null) {
                price = selectedItem.originalPrice; // Revert to original price
                storedSelections[existingItemIndex].price = price;
                selectedItem.discountApplied = false; // Reset discount applied status
                console.log("One-time purchase selected. Reverted to original price:", price);
            }
    
            if (quantity > 0) {
                // Update the quantity and selling plan if the item is already in the selection
                storedSelections[existingItemIndex].quantity = quantity;
                storedSelections[existingItemIndex].selling_plan = selling_plan; // Update the selling plan ID
    
                console.log("Selling Plan Updated to:", selling_plan);
            } else {
                // Remove the item if quantity is 0
                storedSelections.splice(existingItemIndex, 1);
                selectedItem.discountApplied = false;
            }
            console.log("Is Discount Applied?", selectedItem.discountApplied);
        } else if (quantity > 0) {
            // Apply discount for new item if subscription is selected
            if (subscriptionRadio.checked && selling_plan !== null) {
                price = price * 0.85; // Apply 15% discount
                console.log("Discount applied to new item. New price:", price);
            }
    
            // Add new item with quantity, price, and selling plan ID
            storedSelections.push({
                id: variantId,
                quantity: quantity,
                price: parseFloat(price), // Ensure price is a number
                originalPrice: parseFloat(price), // Store the original price as a number
                selling_plan: selling_plan,
                variantImage: variantImage,
                variantName: variantName,
                discountApplied: subscriptionRadio.checked && selling_plan !== null // Track discount status for new items
            });
        }
    
        localStorage.setItem('selectedItems', JSON.stringify(storedSelections));
    
        // Log for debugging
        console.log('Selection saved:', storedSelections);
    }

  // Function to load all selections from localStorage and update the sticky bar
  function loadSelections() {
      const storedSelections = JSON.parse(localStorage.getItem('selectedItems')) || [];
  
      // Restore quantities from localStorage
      storedSelections.forEach(item => {
          const quantityInput = document.getElementById('quantity-' + item.id);
          const minusButton = document.querySelector(`.minus-btn[data-variant-id="${item.id}"]`);
  
          if (quantityInput) {
              quantityInput.value = item.quantity;
              console.log("Hello World", item.quantity );
          } else {
              console.warn(`Quantity input not found for variant ID: ${item.id}`);
          }
  
          if (minusButton) {
              // Adjust the opacity of the minus button based on the quantity
              if (item.quantity === 0) {
                  minusButton.style.opacity = '0.4';
                  minusButton.disabled = true;
              } else {
                  minusButton.style.opacity = '1';
                  minusButton.disabled = false;
              }
          } else {
              console.warn(`Minus button not found for variant ID: ${item.id}`);
          }
      });
  
      updateStickyBar();  // Reflect all items from all categories
  }


    
  if (subscriptionRadio && oneTimeRadio) {
      console.log("Both radio buttons found!");

    // Get references to the radio containers and radio buttons
    const subRadio = document.getElementById('sub-p');
    const oneTimeRadio = document.getElementById('one-time-p');
    

  
      // Listen for changes in the radio group
      document.querySelectorAll('input[name="radio-choice"]').forEach(radio => {
          radio.addEventListener('click', function () {
            // Loop through each variant with selected quantity and update the price based on subscription
            const storedSelections = JSON.parse(localStorage.getItem('selectedItems')) || [];
            storedSelections.forEach(item => {
                const variantId = item.id;
                const quantity = item.quantity;
                const variantImage = item.variantImage;
                const variantName = item.variantName;
                let price = item.price;
                let selling_plan = document.getElementById('selling-plan-' + variantId)?.value || null;
  
                // Trigger saveSelection to store the updated data
                saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                console.log("Selection Saved");
            });

            updateStickyBar();
            console.log("Radio Button Clicked!");
          });
      });
  }

    
    // Dynamic category switching with AJAX
    document.querySelectorAll('.category-btn').forEach(button => {
        button.addEventListener('click', function() {
            const category = this.getAttribute('data-category');
          
            // Remove 'active' class from all buttons
            document.querySelectorAll('.category-btn').forEach(btn => btn.classList.remove('active'));

            // Add 'active' class to the clicked button
            this.classList.add('active');

            fetch(`${ROOT}collections/${category}`)
                .then(response => response.text())
                .then(data => {
                    // Replace the current products with the new ones
                    document.querySelector('.bundle-products').innerHTML = new DOMParser()
                        .parseFromString(data, 'text/html')
                        .querySelector('.bundle-products').innerHTML;

                    // Reattach event listeners for new content
                    attachQuantityButtons();
                    detailsModal();
                    productInfoModal();
                    loadSelections(); // Load previous selections and reflect in sticky bar
                    console.log(`Category switched to: ${category}`);
                })
                .catch(error => console.error('Error fetching category products:', error));

            // Update the URL without reloading the page
            history.pushState(null, '', `${ROOT}collections/${category}`);
        });
    });

    // Handle Add to Cart submission
  
    const selectPlanButton = document.querySelector('.select-plan');
    let inSummaryView = false; // Track whether we are in the summary view
    const backButton = document.getElementById('back-to-previous-view'); // Back button
    const sectionBundleSummary = document.querySelector('.section-bundle-summary');
    const sectionBundleSlider = document.querySelector('.section-bundle-slider');
    const sectionBundleSelector = document.querySelector('.section-bundle-selector');

    function removeViewSummaryFromUrl() {
        const currentUrl = new URL(window.location.href); // Get the current URL
        currentUrl.searchParams.delete('view'); // Remove the 'view' parameter from the URL
        window.history.pushState({}, '', currentUrl); // Update the URL without reloading the page
    }

    // Handle the back button functionality to navigate to the previous URL
    // Check if the backButton exists before adding the event listener
    if (backButton) {
        backButton.addEventListener('click', function () {
            inSummaryView = false;
            removeViewSummaryFromUrl();
            sectionBundleSummary.style.display = 'none';
            sectionBundleSlider.style.display = 'block'; 
            sectionBundleSelector.style.display = 'block'; 
            selectPlanButton.textContent = selectPlanButton.getAttribute('data-standard');
            selectPlanButton.classList.remove('active');
            console.log("In Summary View is", inSummaryView);
        });
    } else {
        console.log("Back button not found");
    }

    // Function to update the button based on the state
    function updateButton() {
        if (inSummaryView) {
            selectPlanButton.textContent = selectPlanButton.getAttribute('data-alternative');
            selectPlanButton.classList.add('active');
        } else {
            selectPlanButton.textContent = selectPlanButton.getAttribute('data-standard');
            selectPlanButton.classList.remove('active');
        }
    }

    // Function to toggle to the summary view
    function redirectToSummaryView() {
        inSummaryView = true;
        updateButton();
        
        // Update the URL to add ?view=summary
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('view', 'summary');
        window.history.pushState({}, '', currentUrl); // Update URL without reload
        
        // Show summary section (assuming you have a section you want to display)

        if (sectionBundleSummary) {
            sectionBundleSummary.style.display = 'block';
        }
    }

    // Add event listener to button click
    if (selectPlanButton) {
        selectPlanButton.addEventListener('click', function () {
            if (!inSummaryView) {
                // First click: redirect to summary view
                redirectToSummaryView();
                sectionBundleSummary.style.display = 'block';
                sectionBundleSlider.style.display = 'none';
                sectionBundleSelector.style.display = 'none';
                // Scroll the page to the top when this block is triggered
                window.scrollTo({
                    top: 0,            // Scroll to the top of the page
                    behavior: 'smooth' // Makes the scroll smooth
                });
                console.log("In Summary View is", inSummaryView)
            } else {
                // Second click: proceed to add to cart
                selectSubscription();
                const storedSelections = JSON.parse(localStorage.getItem('selectedItems')) || [];
    
                if (storedSelections.length > 0) {
                    // Map the selections to the format Shopify expects: variant_id, quantity, selling_plan
                    const requestData = storedSelections.map(item => ({
                        id: item.id,  // variant ID
                        quantity: item.quantity,  // quantity
                        selling_plan: item.selling_plan || null  // optional selling plan ID
                    }));
    
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: requestData })  // Wrap items in an object
                    })
                    .then(response => response.json())
                    .then(() => {
                        window.location.href = `${ROOT}cart`; // Redirect to cart page
                    })
                    .catch(error => console.error('Error adding to cart:', error));
                } else {
                    alert('Please select at least one item to add to the cart.');
                }
    
                resetSelections();  // Clear selections after adding to cart
            }
        });
}


    // On page load, check if already in summary view
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('view') === 'summary') {
        inSummaryView = true;
        sectionBundleSummary.style.display = 'block';
        sectionBundleSlider.style.display = 'none';
        sectionBundleSelector.style.display = 'none';
        updateButton(); // Assuming this function updates the button text or state
    } else if (sectionBundleSlider && sectionBundleSelector) {
        // Check if both sections exist
        sectionBundleSummary.style.display = 'none';
        sectionBundleSlider.style.display = 'block';  // Set display to block if it exists
        sectionBundleSelector.style.display = 'block';  // Set display to block if it exists
    }

  
    // Attach initial event listeners
    attachQuantityButtons();
    detailsModal();
    productInfoModal();
    loadSelections(); // Load previous selections on page load


  //*******************************************************

    // Function to update prices based on radio button selection on page load
    function updatePricesOnPageLoad() {
        let storedSelections = JSON.parse(localStorage.getItem('selectedItems')) || [];
    
        // Iterate through stored selections and update prices based on selected radio button
        storedSelections.forEach(item => {
            let originalPrice = item.originalPrice;
            if (oneTimeRadio.checked) {
                item.price = originalPrice; // Reset to original price
                item.discountApplied = false;
                console.log('Reverted to original price for one-time purchase:', item.price);
            } else if (subscriptionRadio.checked && item.selling_plan !== null) {
                item.price = originalPrice * 0.85; // Apply 15% discount
                item.discountApplied = true;
                console.log('Applied discount for subscription:', item.price);
            }
        });
    
        localStorage.setItem('selectedItems', JSON.stringify(storedSelections)); // Update localStorage
        console.log('Updated selections after page load:', storedSelections);
    }
  
    updatePricesOnPageLoad();


    function selectSubscription() {
        console.log("Select Subscription Running!");
    
          // Fetch saved selections from localStorage
          const savedSelections = JSON.parse(localStorage.getItem('selectedItems')) || [];

          // Filter items with a selling_plan
          const filteredItems = savedSelections.filter(item => item.selling_plan);

          if (filteredItems.length === 0) {
              console.log("No items with a sellingPlanId found.");
              return;
          }

          // Loop through filtered items
          filteredItems.forEach(item => {
              const variantId = item.id;
              const quantity = item.quantity;
              const price = item.price;
              const variantImage = item.variantImage;
              const variantName = item.variantName;
              const dropdown = document.getElementById("dropdown");
              let selling_plan = null;

              if (subscriptionRadio.checked) {
                if (dropdown.value === "option1") {
                  const selling_plan = 780075080; // Assign selling_plan = 1 for subscriptions
                  console.log("Subscription selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                } else if (dropdown.value === "option2") {
                  const selling_plan = 779976776; // Assign selling_plan = 1 for subscriptions
                  console.log("Subscription selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                } else if (dropdown.value === "option3") {
                  const selling_plan = 779944008; // Assign selling_plan = 1 for subscriptions
                  console.log("Subscription selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                } else if (dropdown.value === "option4") {
                  const selling_plan = 768639048; // Assign selling_plan = 1 for subscriptions
                  console.log("Subscription selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                } else if (dropdown.value === "option5") {
                  const selling_plan = 780107848; // Assign selling_plan = 1 for subscriptions
                  console.log("Subscription selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                } else if (dropdown.value === "option6") {
                  const selling_plan = 780140616; // Assign selling_plan = 1 for subscriptions
                  console.log("Subscription selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                } else if (dropdown.value === "option7") {
                  const selling_plan = 780173384; // Assign selling_plan = 1 for subscriptions
                  console.log("Subscription selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                } else if (dropdown.value === "option8") {
                  const selling_plan = 780206152; // Assign selling_plan = 1 for subscriptions
                  console.log("Subscription selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);
                }
              } else if (oneTimeRadio.checked) {
                  const selling_plan = null; 
                  console.log("One-time purchase selected for variant: ", variantId);
                  saveSelection(variantId, quantity, price, selling_plan, variantImage, variantName);// No selling plan for one-time purchase
              }
          });
    }
  }
});